let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ilXRX")).then(() => parcelRequire('8YOns'));